export default "__VITE_ASSET__BUpATt9___"